// extracted by mini-css-extract-plugin
export default {"featuresListPanelComponent":"featuresListPanel_featuresListPanelComponent__M-YJm"};